import {svgIconWrapper} from '../svg-icon-wrapper';

import WrenchRegular from './wrench-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <WrenchRegular {...props} />;
}
SvgComponent.iconName = 'wrenchRegular';

export const WrenchRegularIcon = svgIconWrapper(SvgComponent);
